<template>
    <div id="app">
        <router-view></router-view>
        <page-footer />
        <page-modal />
        <float-btn />
        <loading />
    </div>
</template>

<script>
    import Footer from './components/Footer'
    import Modal from './components/Modal'
    import Loading from './components/partial/Loading'
    import FloatBtn from './components/partial/FloatBtn'

    export default {
        name: 'app',
        components: {
            PageFooter: Footer,
            PageModal: Modal,
            Loading,
            FloatBtn,
        },
        data() {
            return {
                profile: {},
                authorized: false
            }
        },
        mounted() {
            let vm = this
            // facebook 初始化
            window.fbAsyncInit = function () {
                FB.init({
                    appId: '1588003457929939',
                    cookie: true,
                    xfbml: true,
                    version: 'v2.9'
                });
                FB.AppEvents.logPageView();

                // Get FB Login Status
                FB.getLoginStatus(response => {
                    vm.statusChangeCallback(response)
                })
            };
        },
        methods: {
            getProfile() {
                FB.api('/me?fields=name,id,email', function (response) {
                    console.log(response)
                    this.profile = response;
                })
            },
            login() {
                let vm = this
                FB.login(function (response) {
                    vm.statusChangeCallback(response)
                }, {
                    scope: 'email, public_profile',
                    return_scopes: true
                })
            },
            statusChangeCallback(response) {
                let vm = this
                if (response.status === 'connected') {
                    vm.authorized = true
                    vm.getProfile()
                } else if (response.status === 'not_authorized') {
                    vm.authorized = false
                } else if (response.status === 'unknown') {
                    vm.profile = {}
                    vm.authorized = false
                } else {
                    vm.authorized = false
                }
            }
        }
    }
</script>